export const CERTIFICATE_PLACEHOLDERS = [
  "clinicName",
  "clinicAddress",
  "clinicPhone",
  "clinicWhatsapp",
  "clinicWebsite",
  "clinicEmail",
  "certificateNumber",
  "certificateDate",
  "patientName",
  "patientId",
  "patientAge",
  "patientGender",
  "treatmentType",
  "treatmentDescription",
  "treatmentDate",
  "reasonForLeave",
  "leaveStartDate",
  "leaveEndDate",
  "leaveDays",
  "recommendationText",
  "doctorName",
  "doctorQualifications",
  "doctorDesignation",
  "slmcNumber",
] as const;

export type CertificatePlaceholderKey = (typeof CERTIFICATE_PLACEHOLDERS)[number];

export type CertificatePreviewData = Record<CertificatePlaceholderKey, string>;

const PLACEHOLDER_PATTERN = /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g;

export function resolvePlaceholders(
  text: string,
  data: Record<string, string>
): string {
  return text.replace(PLACEHOLDER_PATTERN, (_, key: string) => {
    if (Object.prototype.hasOwnProperty.call(data, key) && data[key] != null) {
      return data[key];
    }
    return `{{${key}}}`;
  });
}

export function applyLabelValueStyle(
  text: string,
  style: "inline" | "stacked"
): string {
  if (style !== "stacked") return text;
  return text.replace(/^([^:\n]+:)\s*/gm, "$1\n");
}
